module.exports = __webpack_public_path__ + "static/media/apple-pay.15ca47bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/apple-pay.svg
// module id = 882
// module chunks = 7